<div class="side-detail-container">
  <h3><mat-icon>account_circle</mat-icon> ข้อมูลผู้ดูแลระบบ</h3>
  <ng-container *ngIf="admin">
    <h4>ข้อมูลทั่วไป</h4>
    <app-modal-input [readonly]="readonly" inLabel="ชื่อผู้ดูแล" [inF]="fg.get('name')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>ชื่อผู้ดูแล</mat-label>
          <input matInput placeholder="ชื่อผู้ดูแล" [formControl]="fg.get('name')" required>
          <mat-error>{{e.addUserRequiredName}}</mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <app-modal-input [readonly]="true" inLabel="อีเมลล์ของผู้ดูแล" [inF]="fg.get('email')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>อีเมลล์ของผู้ดูแล</mat-label>
          <input matInput placeholder="อีเมลล์ของผู้ดูแล" [formControl]="fg.get('email')" required>
          <mat-error *ngIf="fg.get('email').hasError('required')">{{e.addUserRequiredEmail}}</mat-error>
          <mat-error *ngIf="fg.get('email').hasError('email')">{{e.addUserFormatEmail}}</mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <app-modal-input [readonly]="readonly" inLabel="เบอร์โทรศัพท์ของผู้ดูแล" [inF]="fg.get('phoneNumber')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>เบอร์โทรศัพท์ของผู้ดูแล</mat-label>
          <input matInput placeholder="เบอร์โทรศัพท์ของผู้ดูแล" [formControl]="fg.get('phoneNumber')" required>
          <mat-error>{{e.addUserRequiredPhone}}</mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <div class="button-label-fill" style="display:none">
      <label>รหัสผ่าน</label>
      ​<div class="flex-spacer"></div>
      <button mat-stroked-button color="primary" (click)="openChangePassword()">เปลี่ยนรหัสผ่าน</button>
    </div>
    <h4>สถานะผู้ดูแล</h4>
    <ng-container *ngIf="readonly;else canToggle">
      <span *ngIf="admin.isEnabled" class="enabled"> สามารถให้บริการได้</span>
      <span *ngIf="!admin.isEnabled" class="disabled"> ไม่สามารถให้บริการได้</span>
    </ng-container>
    <ng-template #canToggle>
      <mat-slide-toggle  color="primary"
          class="radio-label-fill" labelPosition="before" 
          #slide [(ngModel)]="admin.isEnabled" (change)="confirmEnableChanged($event)">
        <span *ngIf="admin.isEnabled" class="enabled"> สามารถใช้งานได้</span>
        <span *ngIf="!admin.isEnabled" class="disabled"> ไม่สามารถใช้งานได้</span>
      </mat-slide-toggle>
    </ng-template>
    <div class="flex-spacer"></div>
    <div class="text-center">
      <button
          mat-stroked-button color="warn" 
          (click)="confirmDeleteDialog()"
          *ngIf="!readonly && admin && admin.role !== 'super-admin'">
        ลบผู้ดูแลระบบ
      </button>
    </div>
  </ng-container>
</div>
